import { createContext, useContext } from 'react';

interface BackupsDrawerContextValue {
	onSuccess?: () => void;
}

const BackupsDrawerContext = createContext<BackupsDrawerContextValue>({});

export const BackupsDrawerProvider = BackupsDrawerContext.Provider;

export const useBackupsDrawerContext = () => useContext(BackupsDrawerContext);
